import { FC, ReactNode } from 'react';

import RichtextComponent from '@/components/core/RichtextComponent';

export interface ProseLayoutProps {
  content?: ReactNode;
  size?: string;
  center?: boolean;
  animate?: boolean;
  color?: string;
  delay?: number;
}

const ProseLayout: FC<ProseLayoutProps> = ({
  content,
  size = 'base',
  center = false,
  color = 'base',
}) => {
  let proseSizes;
  switch (size) {
    case 'sm':
      proseSizes = 'prose prose-base md:prose-lg';
      break;
    case 'base':
      proseSizes = 'prose prose-lg md:prose-xl';
      break;
    case 'lg':
      proseSizes = 'prose prose-xl md:prose-2xl';
      break;
    case 'xl':
      proseSizes = 'prose prose-2xl md:prose-3xl';
      break;
    default:
      proseSizes = 'prose';
  }

  let proseCenter;
  switch (center) {
    case true:
      proseCenter = `
        prose-center
        max-w-none
        prose-headings:mx-auto
        prose-p:mx-auto
        prose-ul:mx-auto
        prose-ol:mx-auto
        prose-headings:max-w-prose
        prose-p:max-w-prose
        prose-ul:max-w-prose
        prose-ol:max-w-prose`;
      break;
    case false:
      proseCenter = `
        prose-headings:mr-auto
        prose-p:mr-auto
        prose-ul:mr-auto
        prose-ol:mr-auto
        prose-headings:max-w-5xl
        prose-p:max-w-5xl
        prose-ul:max-w-5xl
        prose-ol:max-w-5xl`;
      break;
    default:
      proseCenter = '';
  }

  let proseColor;
  switch (color) {
    case 'white':
      proseColor = `prose-white`;
      break;
    case 'beige':
      proseColor = `prose-beige`;
      break;
    case 'base':
      proseColor = `prose-neutral`;
      break;
    case 'neutral':
      proseColor = `text-neutral-600`;
      break;
    default:
      proseColor = '';
  }

  return (
    <div
      className={`${proseSizes} ${proseCenter} ${proseColor} prose-a:text-theme-primary prose-headings:font-normal prose-strong:font-normal`}
    >
      <RichtextComponent content={content} />
    </div>
  );
};

export default ProseLayout;
